import type { DocSection, DocGroup, DocHeading } from "@/site-kit/types";

import OverviewMdx from "@/content/docs/aiapp-design/getting-started/overview.mdx";
import QuickStartMdx from "@/content/docs/aiapp-design/getting-started/quick-start.mdx";
import DesignGuidelinesMdx from "@/content/docs/aiapp-design/guides/design-guidelines.mdx";
import ActionsMdx from "@/content/docs/aiapp-design/guides/actions.mdx";
import ReceiptsMdx from "@/content/docs/aiapp-design/guides/receipts.mdx";
import ApprovalCardMdx from "@/content/docs/aiapp-design/components/approval-card.mdx";
import DataTableMdx from "@/content/docs/aiapp-design/components/data-table.mdx";
import ItemCarouselMdx from "@/content/docs/aiapp-design/components/item-carousel.mdx";
import LinkPreviewMdx from "@/content/docs/aiapp-design/components/link-preview.mdx";
import metadata from "./docs-metadata.json";

type MetadataEntry = {
  headings: DocHeading[];
  rawContent: string;
};

const meta = metadata as Record<string, MetadataEntry>;

export const docGroups: DocGroup[] = [
  {
    label: "Getting Started",
    sections: [
      {
        id: "overview",
        title: "Overview",
        Component: OverviewMdx,
        headings: [...(meta.overview?.headings ?? [])],
        rawContent: meta.overview?.rawContent ?? "",
      },
      {
        id: "quick-start",
        title: "Quick Start",
        Component: QuickStartMdx,
        headings: [...(meta["quick-start"]?.headings ?? [])],
        rawContent: meta["quick-start"]?.rawContent ?? "",
      },
    ],
  },
  {
    label: "Guides",
    sections: [
      {
        id: "design-guidelines",
        title: "Design Guidelines",
        Component: DesignGuidelinesMdx,
        headings: [...(meta["design-guidelines"]?.headings ?? [])],
        rawContent: meta["design-guidelines"]?.rawContent ?? "",
      },
      {
        id: "actions",
        title: "Actions",
        Component: ActionsMdx,
        headings: [...(meta.actions?.headings ?? [])],
        rawContent: meta.actions?.rawContent ?? "",
      },
      {
        id: "receipts",
        title: "Receipts",
        Component: ReceiptsMdx,
        headings: [...(meta.receipts?.headings ?? [])],
        rawContent: meta.receipts?.rawContent ?? "",
      },
    ],
  },
  {
    label: "Components",
    sections: [
      {
        id: "approval-card",
        title: "Approval Card",
        Component: ApprovalCardMdx,
        headings: [...(meta["approval-card"]?.headings ?? [])],
        rawContent: meta["approval-card"]?.rawContent ?? "",
      },
      {
        id: "data-table",
        title: "Data Table",
        Component: DataTableMdx,
        headings: [...(meta["data-table"]?.headings ?? [])],
        rawContent: meta["data-table"]?.rawContent ?? "",
      },
      {
        id: "item-carousel",
        title: "Item Carousel",
        Component: ItemCarouselMdx,
        headings: [...(meta["item-carousel"]?.headings ?? [])],
        rawContent: meta["item-carousel"]?.rawContent ?? "",
      },
      {
        id: "link-preview",
        title: "Link Preview",
        Component: LinkPreviewMdx,
        headings: [...(meta["link-preview"]?.headings ?? [])],
        rawContent: meta["link-preview"]?.rawContent ?? "",
      },
    ],
  },
];

export const allSections: DocSection[] = docGroups.flatMap((g) => g.sections);
